import { Component, Input } from '@angular/core'
import { KeyValuePipe } from '@angular/common'

@Component({
    selector: 'app-server-errors-list',
    imports: [KeyValuePipe],
    templateUrl: './server-errors-list.component.html',
    styleUrl: './server-errors-list.component.scss'
})
export class ServerErrorsListComponent {
  @Input() errors: { [key: string]: any } = {}
}
